<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <TableTips :title="$t('log.operationLog')" :total="pagination.total" />
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearchList">
          <a-form-item>
            <a-select
              style="width: 160px"
              :placeholder="$t('log.operatorTypeTxt')"
              :options="operatorTypeOptions"
              v-decorator="['operatorType', { initialValue: '' }]"
            />
          </a-form-item>
          <a-form-item>
            <a-range-picker
              dropdownClassName="form-date-picker"
              :getCalendarContainer="trigger => trigger.parentNode"
              style="width: 280px"
              format="YYYY-MM-DD"
              :placeholder="[$t('log.startTimeTxt'), $t('log.endTimeTxt')]"
              :ranges="searchDateRangesBtn"
              v-decorator="['dateRange', {initialValue: [moment(), moment()]}]"
              :disabledDate="current => current > moment()"
            />
          </a-form-item>

          <a-form-item style="margin-right:0">
            <a-button type="primary" html-type="submit" :loading="loading">{{$t('log.searchBtn')}}</a-button>
          </a-form-item>
        </a-form>
      </div>

      <div class="time-line">
        <template v-if="logsData.length">
          <template v-for="dateLog in logsData">
            <div class="time-line-body" :key="dateLog.date">
              <div class="date-content">
                <a-tag color="#108ee9">
                  <a-icon style="font-size:18px;" type="calendar" />
                  <span style="font-size:15px;margin: 0 10px">
                    {{dateLog.date}}
                    <span v-if="dateLog.dateTag"> ({{$t(dateLog.dateTag)}}) </span>
                  </span>
                </a-tag>
              </div>
              <a-timeline class="time-content" mode="left">
                <template v-for="log in dateLog.content">
                  <a-timeline-item :key="log.time + log.key" >
                    <a-tag color="blue" class="time">{{log.time}}</a-tag>
                    <div class="detail">
                      <p v-if="log.operatorType===1">操作来源: {{log.operatorName}} </p>
                      <p v-if="log.operatorType===2">
                        操作来源: 设备端
                        <span>(设备名称: {{log.operatorName}}, SN: {{log.operatorDeviceSn}})</span>
                      </p>
                      <p>操作类型: {{log.typeName}}</p>
                      <p>详细描述: {{log.description}}</p>
                    </div>
                  </a-timeline-item>
                </template>
                <a-timeline-item>
                  <a-icon slot="dot" type="small-dash" class="line-bottom" />
                </a-timeline-item>
              </a-timeline>
            </div>
          </template>
        </template>
        <template v-else>
          <a-empty class="time-line-empty" :description="$t('log.noData')"/>
        </template>
      </div>

      <a-pagination
        v-if="pagination.total"
        style="text-align:right; padding-top:26px;"
        :current="pagination.current"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import './common/timeLine.less';
import setDateRangesBtn from './common/setDateRangesBtn';
import createTimeLineData from './common/createTimeLineData';

import moment from 'moment';
import TableTips from '@/components/TableTips';
import { getOperationLogs } from '@/api/logMana';
import { mapState } from 'vuex';

export default {
  name: 'operationLog',
  components: { TableTips },
  data() {
    return {
      logsData: [],
      loading: false,
      listSearchForm: this.$form.createForm(this),
      operatorTypeOptions: [],
      operatorType: '',
      searchFromDate: moment().format('YYYY-MM-DD'),
      searchToDate: moment().format('YYYY-MM-DD'),
      searchDateRangesBtn: setDateRangesBtn(this),

      pagination: {
        current: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  watch: {
    lang: function (lang) {
      this.searchDateRangesBtn = setDateRangesBtn(this)
      this.operatorTypeOptions = [].concat([{ title: this.$t('log.option_all'), value: '', key: 'all' }], this.logOperatorType);
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      logOperatorType: state => state.enumsStore.enumsData.logOperatorType
    })
  },
  created() {
    this.operatorTypeOptions = [].concat([{ title: this.$t('log.option_all'), value: '', key: 'all' }], this.logOperatorType);
    this.getLogData()
  },
  methods: {
    moment,
    // 搜索
    handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD');
          this.searchToDate = values.dateRange[1].format('YYYY-MM-DD');
          this.operatorType = values.operatorType ? Number(values.operatorType) : undefined;
          this.pagination.current = 1;
          this.getLogData();
        }
      });
    },
    // 获取操作日志
    async getLogData() {
      try {
        console.log(this.$message)
        // this.$message.loading(this.$t('log.logLoading'), 0)
        this.loading = true
        const res = await getOperationLogs({
          fromDate: this.searchFromDate,
          toDate: this.searchToDate,
          operatorType: this.operatorType,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        // this.$message.destroy()
        this.loading = false

        this.logsData = createTimeLineData(res.data.collection, 'operate')
        this.pagination.total = res.data.size
      } catch (error) {
        // this.$message.destroy()
        this.loading = false
      }
    },
    // 点击分页时触发
    handlePageChange(page, pageSize) {
      // console.log('-------handlePageChange------', page, pageSize);
      this.pagination.current = page;
      this.getLogData();
    }
  }
}
</script>

<style lang="less" scoped>
</style>
